import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class DividendRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Dátum</TableCell>
                            <TableCell>Nettó öszeg</TableCell>
                            <TableCell>Bruttó öszeg</TableCell>
                            <TableCell>Megjegyzés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.date}</TableCell>
                            <TableCell>{this.props.row.netAmount}</TableCell>
                            <TableCell>{this.props.row.grossAmount}</TableCell>
                            <TableCell>{this.props.row.comment}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default DividendRow;